var map = {
	"./bg1.jpg": 1205,
	"./bg2.jpg": 1206,
	"./bg3.jpg": 1207,
	"./bg4.jpg": 1208,
	"./bg5.jpg": 1209,
	"./bg6.jpg": 1210,
	"./bg7.jpg": 1211
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2105;


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth/img/bg ^\.\/.*$
// module id = 2105
// module chunks = 18